var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page)?_c('page-item',{attrs:{"content":_vm.$route.params.window === 'about' ? _vm.about : _vm.page[0]}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }